// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EditCourseController from "./admin/edit_course_controller"
application.register("edit-course", EditCourseController)

import CarouselTestimonialsController from "./carousel_testimonials_controller"
application.register("carousel-testimonials", CarouselTestimonialsController)

import ChoicesDropdownController from "./choices_dropdown_controller";
application.register("choices-dropdown", ChoicesDropdownController);

import ChoicesTextController from "./choices_text_controller";
application.register("choices-text", ChoicesTextController);

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController);

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController);

import DisplayChakrasProgressController from "./display_chakras_progress_controller"
application.register("display-chakras-progress", DisplayChakrasProgressController);

import EditVideoCommentController from "./edit_video_comment_controller"
application.register("edit-video-comment", EditVideoCommentController)

import EmailController from "./email_controller"
application.register("email", EmailController)

import MeetingSubscriptionController from "./meeting_subscription_controller"
application.register("meeting-subscription", MeetingSubscriptionController)

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PurchaseController from "./purchase_controller"
application.register("purchase", PurchaseController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController);

import TableClickController from "./table_click_controller"
application.register("table-click", TableClickController);

import TogglePlaylistFavoritesController from "./toggle_playlist_favorites_controller"
application.register("toggle-playlist-favorites", TogglePlaylistFavoritesController)

import ToggleVideoFavoritesController from "./toggle_video_favorites_controller"
application.register("toggle-video-favorites", ToggleVideoFavoritesController)

import ToolTipController from "./tooltip_controller"
application.register("tooltip", ToolTipController)

import ValidateSelectionController from "./validate_selection_controller"
application.register("validate-selection", ValidateSelectionController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)
